import { fetchConToken } from "../helpers/fetch";


const estudiosMedicosServi = {
    getEstudiosMedicos: (idEstado, fechaInicio, fechaFin, idAfiliado, idObraSocial) => {
        return fetchConToken(`EstudiosMedicos/${idEstado}/${fechaInicio}/${fechaFin}/${idAfiliado}/${idObraSocial}`);
    },
    getEstudiosMedicosContadores: (idEstado, fechaInicio, fechaFin, idAfiliado, idObraSocial) => {
        return fetchConToken(`EstudiosMedicos/Contadores/${idEstado}/${fechaInicio}/${fechaFin}/${idAfiliado}/${idObraSocial}`);
    },
    updateEstudiosMedicos: (data) => {
        return fetchConToken(`EstudiosMedicos`, data, "PUT")
    },
    getEstadosEstudiosMedicos: () => {
        return fetchConToken(`EstudiosMedicos/EstadosEstudiosMedicos`);
    },
    getinformesMed: (idAgenda) => {
        return fetchConToken(`EstudiosMedicos/TraerInformesPaciente/${idAgenda}`);
    },
    cambioEstado: (data) => {
        return fetchConToken(`EstudiosMedicos/cambiarEstado`, data, "PUT")
    },
    enviarInformeConImg: (idAgenda) => {
        return fetchConToken(`EstudiosMedicos/envioInformeConImagen/${idAgenda}`);
    },
    enviarEstudioConImg: (idAgenda) => {
        return fetchConToken(`EstudiosMedicos/envioEstudio/${idAgenda}`);
    },
    getTracking: (idEstudioMedico) => {
        return fetchConToken(`EstudiosMedicos/Tracking/${idEstudioMedico}`);
    },
    getTipoNotas: () => {
        return fetchConToken(`EstudiosMedicos/TipoNotas`);
    },
    getNotas: (idEstudioMedico) => {
        return fetchConToken(`EstudiosMedicos/Notas/${idEstudioMedico}`);
    },
    postNotas: (data) => {
        return fetchConToken(`EstudiosMedicos/Notas`, data, "POST")
    },

    
};

export default estudiosMedicosServi;




